import { memo } from 'react';

import Typography from 'components/UI/Typography/Typography';
import BonusOpportunity from 'components/pages/RewardSystem/Rules/BonusOpportunity/BonusOpportunity';
import BonusTasks from 'components/pages/RewardSystem/Rules/BonusTasks/BonusTasks';
import HowItWorks from 'components/pages/RewardSystem/Rules/HowItWorks/HowItWorks';

import styles from './Rules.module.scss';

const Rules = () => (
  <div className={styles.root}>
    <div className={styles.headings}>
      <Typography type="heading-md" weight="medium" uppercase>
        B2B Reward system rules
      </Typography>
      <Typography color="grey" className={styles.description}>
        Welcome to the{' '}
        <Typography element="span" weight="semibold">
          Evoplay Reward System
        </Typography>{' '}
        — a dynamic two-tiered program crafted exclusively for our valued B2B
        partners. Earn rewards by achieving marketing goals and meeting key
        business performance indicators.
      </Typography>
    </div>
    <HowItWorks />
    <BonusOpportunity />
    <BonusTasks />
  </div>
);

export default memo(Rules);
